import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
  MatBottomSheet,
} from '@angular/material/bottom-sheet';
import { FoodFactCreate } from 'src/app/core/model/api-response/persoanl-response-model';
import { packagesFood } from 'src/app/core/model/api-response/plans-response-model';
import {
  FoodFactModel,
  FoodFactsModel,
  FoodModel,
  FoodUnitRatioModel,
} from 'src/app/core/model/object/diet-food-model';
import { DietSearchMealModel } from 'src/app/core/model/object/diet-model';
import { FoodLogModel } from 'src/app/core/model/object/foodlog-model';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { PlansService } from 'src/app/data/repository/plans-repository/plans.service';
import { RecipeService } from 'src/app/data/repository/recipe-repository/recipe.service';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { BottomsheetShared } from 'src/app/presentation/general/shared/bottomsheet-shared';
import { PlanShared } from 'src/app/presentation/general/shared/plan-shared';
import { CalorieCalculator } from 'src/app/utils/calorie-calculator';
interface suggest {
  id: string;
  foods: packagesFood[];
  amount: {
    amount: number;
  }[];
}
@Component({
  selector: 'app-plan-overview-bottomsheet-showdetail',
  templateUrl: './plan-overview-bottomsheet-showdetail.component.html',
  styles: [
    `
      .title {
        position: relative;
        width: calc(100% - 120px);
        height: 28px;
        top: 0;
        right: 16px;
        color: #000;
        font-family: Vazir-Bold !important;
        font-size: 18px;
        font-weight: 700;
        letter-spacing: 0;
        text-align: right;
        line-height: 28px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0;
        margin-top: 0;
        margin-top: 16px;
      }
      .label {
        position: absolute;
        height: 24px;
        z-index: 3;
        width: auto;
        left: 16px;
        top: 16px;
        padding: 0 12px;
        border-radius: 8px;
        border: 1px solid #0073ff;
        color: #0073ff;
        background: #fff;
        font-family: Vazir !important;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: 0;
        text-align: center;
      }
      .detail-list {
        width: calc(100% - 32px);
        height: 24px;
        display: flex;
        justify-content: space-between;
        margin: 0 auto;
        margin-top: 16px;
      }
      .detail-title {
        width: 62%;
        height: 24px;
        color: #000;
        font-size: 16px;
        letter-spacing: 0;
        text-align: right;
        line-height: 24px;
        display: inline-block;
        vertical-align: top;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .description {
        position: relative;
        width: 35%;
        height: 24px;
        color: #6e6e6e;
        font-size: 16px;
        letter-spacing: 0;
        text-align: left;
        line-height: 24px;
        display: inline-block;
        vertical-align: top;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .center {
        display: flex;
        justify-content: center;
        margin-bottom: 16px;
      }
      .change-package-button {
        display: inline-flex;
        background: #0f61c4;
        padding: 0 12px;
        border-radius: 10px;
        border: 1px solid #0f61c4;
        box-shadow: inset 0px -1px 0px 0px rgb(0 0 0 / 10%),
          inset 0px 0.5px 0px 0px rgb(255 255 255 / 50%);
        height: 48px;
        color: #fff;
        font-family: Vazir-Medium !important;
        font-size: 16px;
        font-weight: 500;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        margin-top: 24px;
        text-align: center;
        position: relative;
      }
      .link-to-recipe {
        color: #0f61c4 !important;
        display: inline-flex !important;
        align-items: center !important;
      }
      .link-to-recipe img {
        width: 16px;
        height: 16px;
        padding-left: 8px;
      }
    `,
  ],
})
export class PlanOverviewBottomsheetShowdetailComponent implements OnInit {
  foodFactsAmount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  showFoodFactDetail;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: {
      suggest: suggest;
      title: string;
      day: string;
      meal: string;
      dietId: string;
    },

    private bottomSheetRef: MatBottomSheetRef<PlanOverviewBottomsheetShowdetailComponent>,
    private matBottomSheet: MatBottomSheet,
    private planService: PlanService,
    private planShared: PlanShared,
    private plansService: PlansService,
    private snackBarService: SnackBarService,
    public calorieCalculator: CalorieCalculator,
    private bottomsheetShared: BottomsheetShared,
    private recipeService: RecipeService
  ) {}
  changePackage(foods, amount, id) {
    const mealPackage = new DietSearchMealModel(
      id,
      this.data.meal,
      foods,
      amount
    );
    const day =
      parseInt(this.data.day) === 31
        ? parseInt(this.data.day) - 1
        : parseInt(this.data.day) + 1;

    this.planService
      .changePackage(
        this.data.dietId,
        mealPackage,
        day.toString(),
        this.data.meal
      )
      .then((res) => {
        if (res.isSuccess()) {
          this.planShared.refreshMyPlan();

          this.plansService.AddRecentPackage(mealPackage, this.data.meal);
          this.planService.closeBottomSheet.next(true);
          this.bottomSheetRef.dismiss();
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
      });
  }
  ngOnInit(): void {}
  openChart(s: suggest) {
    let res;
    let selectedFood;
    const d = s.foods.map((v, i) => {
      const ratio = this.calorieCalculator.findSuggestionRatio(v);
      const foodModel = new FoodModel(
        v._id,
        v.foodId.name,
        v.foodId.primaryFoodUnit,
        v.foodId.foodFact.calorieAmount,
        v.foodId.foodUnitRatioArray,
        v.foodId.foodFact,
        this.makeFoodFactsModel(v.foodId.foodFact)
      );
      selectedFood = new FoodLogModel(
        s.amount[i].amount,
        0,
        v.foodId._id,
        '',
        v.foodId.primaryFoodUnit,
        '',
        foodModel,
        v._id
      );
      res = this.prepareFoodFactsAmounts(
        selectedFood,
        this.foodFactsAmount,
        ratio
      );
      res[0] = this.calorieCalculator.calculateSuggestions(s.foods, s.amount);
      res = res.map((v) => parseFloat((v as number).toFixed(1)));
    });

    this.bottomsheetShared.selectedFoodFactsAmounts = res;
    this.bottomsheetShared.selectedFoodFactsNames =
      this.prepareFoodFactsPersianNames(selectedFood);
    this.bottomsheetShared.selectedFoodFactsUnits =
      this.prepareFoodFactsPersianUnits(selectedFood);
    this.bottomsheetShared.openFoodFactBottomsheet();
    this.planService.openTable.next(true);
    this.bottomSheetRef.dismiss();
  }
  goToRecipe(id: string) {
    this.recipeService.goToRecipeDetail(id);
    this.bottomSheetRef.dismiss();
  }
  prepareFoodFactsAmounts(
    food: FoodLogModel,
    foodFactsAmount: number[],
    ratio: FoodUnitRatioModel
  ): number[] {
    if (food.calorie && food.title) {
      foodFactsAmount[0] = food.calorie + foodFactsAmount[0];
    } else {
      foodFactsAmount[0] =
        food.foodModel.foodFactModel.calorie.amount !== -1 &&
        this.foodFactsAmount[0] !== -1
          ? ((food.foodModel.foodFactModel.calorie.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[0]
          : 0;
      foodFactsAmount[1] =
        food.foodModel.foodFactModel.protein.amount !== -1 &&
        this.foodFactsAmount[1] !== -1
          ? ((food.foodModel.foodFactModel.protein.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[1]
          : 0;
      foodFactsAmount[2] =
        food.foodModel.foodFactModel.carbohydrate.amount !== -1 &&
        this.foodFactsAmount[2] !== -1
          ? ((food.foodModel.foodFactModel.carbohydrate.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[2]
          : 0;
      foodFactsAmount[3] =
        food.foodModel.foodFactModel.fat.amount !== -1 &&
        this.foodFactsAmount[3] !== -1
          ? ((food.foodModel.foodFactModel.fat.amount * food.amount) / 100) *
              ratio.ratio +
            foodFactsAmount[3]
          : 0;
      foodFactsAmount[4] =
        food.foodModel.foodFactModel.sugar.amount !== -1 &&
        this.foodFactsAmount[4] !== -1
          ? ((food.foodModel.foodFactModel.sugar.amount * food.amount) / 100) *
              ratio.ratio +
            foodFactsAmount[4]
          : 0;
      foodFactsAmount[5] =
        food.foodModel.foodFactModel.fiber.amount !== -1 &&
        this.foodFactsAmount[5] !== -1
          ? ((food.foodModel.foodFactModel.fiber.amount * food.amount) / 100) *
              ratio.ratio +
            foodFactsAmount[5]
          : 0;
      foodFactsAmount[6] =
        food.foodModel.foodFactModel.sodium.amount !== -1 &&
        this.foodFactsAmount[6] !== -1
          ? ((food.foodModel.foodFactModel.sodium.amount * food.amount) / 100) *
              ratio.ratio +
            foodFactsAmount[6]
          : 0;
      foodFactsAmount[7] =
        food.foodModel.foodFactModel.potassium.amount !== -1 &&
        this.foodFactsAmount[7] !== -1
          ? ((food.foodModel.foodFactModel.potassium.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[7]
          : 0;
      foodFactsAmount[8] =
        food.foodModel.foodFactModel.calcium.amount !== -1 &&
        this.foodFactsAmount[8] !== -1
          ? ((food.foodModel.foodFactModel.potassium.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[8]
          : 0;
      foodFactsAmount[9] =
        food.foodModel.foodFactModel.magnesium.amount !== -1 &&
        this.foodFactsAmount[9] !== -1
          ? ((food.foodModel.foodFactModel.magnesium.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[9]
          : 0;
      foodFactsAmount[10] =
        food.foodModel.foodFactModel.phosphor.amount !== -1 &&
        this.foodFactsAmount[10] !== -1
          ? ((food.foodModel.foodFactModel.phosphor.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[10]
          : 0;
      foodFactsAmount[11] =
        food.foodModel.foodFactModel.iron.amount !== -1 &&
        this.foodFactsAmount[11] !== -1
          ? ((food.foodModel.foodFactModel.iron.amount * food.amount) / 100) *
              ratio.ratio +
            foodFactsAmount[11]
          : 0;
      foodFactsAmount[12] =
        food.foodModel.foodFactModel.saturatedFat.amount !== -1 &&
        this.foodFactsAmount[12] !== -1
          ? ((food.foodModel.foodFactModel.saturatedFat.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[12]
          : 0;
      foodFactsAmount[13] =
        food.foodModel.foodFactModel.monounsaturatedFat.amount !== -1 &&
        this.foodFactsAmount[13] !== -1
          ? ((food.foodModel.foodFactModel.monounsaturatedFat.amount *
              food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[13]
          : 0;
      foodFactsAmount[14] =
        food.foodModel.foodFactModel.polyunsaturatedFat.amount !== -1 &&
        this.foodFactsAmount[14] !== -1
          ? ((food.foodModel.foodFactModel.polyunsaturatedFat.amount *
              food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[14]
          : 0;
      foodFactsAmount[15] =
        food.foodModel.foodFactModel.transFat.amount !== -1 &&
        this.foodFactsAmount[15] !== -1
          ? ((food.foodModel.foodFactModel.transFat.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[15]
          : 0;
      foodFactsAmount[16] =
        food.foodModel.foodFactModel.cholesterol.amount !== -1 &&
        this.foodFactsAmount[16] !== -1
          ? ((food.foodModel.foodFactModel.cholesterol.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[16]
          : 0;
    }
    foodFactsAmount.map((v, i) => {
      if (v === v && v % 1 !== 0) foodFactsAmount[i] = Number(v.toFixed(1));
    });
    return foodFactsAmount;
  }
  prepareFoodFactsPersianNames(food: FoodLogModel): string[] {
    return [
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.calorie.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.protein.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.carbohydrate.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.fat.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.sugar.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.fiber.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.sodium.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.potassium.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.calcium.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.magnesium.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.phosphor.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.iron.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.saturatedFat.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.monounsaturatedFat.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.polyunsaturatedFat.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.transFat.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.cholesterol.name
      ),
    ];
  }

  prepareFoodFactsPersianUnits(food: FoodLogModel): string[] {
    return [
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.calorie.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.protein.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.carbohydrate.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.fat.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.sugar.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.fiber.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.sodium.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.potassium.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.calcium.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.magnesium.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.phosphor.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.iron.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.saturatedFat.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.monounsaturatedFat.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.polyunsaturatedFat.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.transFat.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.cholesterol.name
      ),
    ];
  }
  makeFoodFactsModel(f: FoodFactCreate): FoodFactsModel {
    const calorie = new FoodFactModel('calorie', f.calorieAmount);
    const protein = new FoodFactModel('protein', f.proteinAmount);
    const fat = new FoodFactModel('fat', f.fatAmount);
    const carbohydrat = new FoodFactModel('carbohydrate', f.carbohydrateAmount);
    const sugar = new FoodFactModel('sugar', f.sugarAmount);
    const fiber = new FoodFactModel('fiber', f.fiberAmount);
    const sodium = new FoodFactModel('sodium', f.sodiumAmount);
    const potassium = new FoodFactModel('potassium', f.potassiumAmount);
    const calcium = new FoodFactModel('calcium', f.calciumAmount);
    const magnesium = new FoodFactModel('magnesium', f.magnesiumAmount);
    const iron = new FoodFactModel('iron', f.ironAmount);
    const cholesterol = new FoodFactModel('cholesterol', f.cholesterolAmount);
    const phosphor = new FoodFactModel('phosphor', f.phosphorAmount);
    const saturatedFat = new FoodFactModel(
      'saturatedFat',
      f.saturatedFatAmount
    );
    const polyunsaturatedFat = new FoodFactModel(
      'polyunsaturatedFat',
      f.polyunsaturatedFatAmount
    );
    const transFat = new FoodFactModel('transFat', f.transFatAmount);
    const monounsaturatedFat = new FoodFactModel(
      'monounsaturatedFat',
      f.monounsaturatedFatAmount
    );
    return new FoodFactsModel(
      calorie,
      protein,
      fat,
      carbohydrat,
      sugar,
      fiber,
      sodium,
      potassium,
      calcium,
      magnesium,
      iron,
      cholesterol,
      phosphor,
      saturatedFat,
      polyunsaturatedFat,
      transFat,
      monounsaturatedFat
    );
  }
}
